import React, { memo } from 'react';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Badge } from '../../components/ui/badge';
import { PhoneCall } from 'lucide-react';
import { format } from 'date-fns';

// Memoized Call Card
const CallCard = memo(({ call, onClick }) => (
  <div 
    className="p-4 border rounded-lg hover:shadow-sm hover:border-blue-200 transition-all cursor-pointer"
    onClick={() => onClick(call)}
    data-testid={`call-card-${call.id}`}
  >
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-3">
        <Badge variant="outline">{call.direction}</Badge>
        <Badge className={call.outcome === 'connected' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}>
          {call.outcome?.replace('_', ' ')}
        </Badge>
        <span className="text-sm text-muted-foreground">
          {call.duration_minutes || Math.floor((call.duration_seconds || 0) / 60)} min
        </span>
      </div>
      <span className="text-xs text-muted-foreground">
        {format(new Date(call.created_at), 'MMM d, yyyy h:mm a')}
      </span>
    </div>
    {call.notes && <p className="text-sm text-muted-foreground line-clamp-2">{call.notes}</p>}
  </div>
));

CallCard.displayName = 'CallCard';

// Main CallsTab component
const CallsTab = memo(({ calls, onCallClick }) => {
  if (calls.length === 0) {
    return (
      <div className="text-center py-12">
        <PhoneCall className="h-12 w-12 text-slate-300 mx-auto mb-3" />
        <p className="text-muted-foreground">No calls logged</p>
      </div>
    );
  }

  return (
    <ScrollArea className="h-[550px]">
      <div className="p-4">
        <div className="space-y-3">
          {calls.map(call => (
            <CallCard 
              key={call.id} 
              call={call} 
              onClick={onCallClick}
            />
          ))}
        </div>
      </div>
    </ScrollArea>
  );
});

CallsTab.displayName = 'CallsTab';

export default CallsTab;
